import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
import store from '@/store';
export default [{
  path: '/create_team/monitor_info/:activityId',
  name: ROUTE_NAME.CREATE_TEAM_MONITOR_INFO,
  meta: {
    title: function title(to) {
      var basicInfo = store.state.activity.basicInfo[to.params.activityId];
      var name = basicInfo ? basicInfo.name : '';
      return name + "\u961F\u957F\u4FE1\u606F\u63D0\u4EA4";
    },
    shareWord: false,
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "create_team" */
      '@/pages/createTeam/monitorInfo.vue'),
      loading: Loading
    };
  }
}, // todo: 是否有必要?
{
  path: '/create_team/monitor_info',
  redirect: function redirect(to) {
    return {
      name: ROUTE_NAME.CREATE_TEAM_MONITOR_INFO,
      params: {
        activityId: '2'
      }
    };
  }
}, {
  path: '/create_team/monitor_check/:activityId',
  name: ROUTE_NAME.CREATE_TEAM_MONITOR_CHECK,
  meta: {
    title: function title(to) {
      var basicInfo = store.state.activity.basicInfo[to.params.activityId];
      var name = basicInfo ? basicInfo.name : '';
      return name + "\u961F\u957F\u4FE1\u606F\u5BA1\u6838";
    },
    shareWord: false,
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "create_team" */
      '@/pages/createTeam/monitorCheck.vue'),
      loading: Loading
    };
  }
}, {
  path: '/create_team/team_info',
  redirect: function redirect(to) {
    return {
      name: ROUTE_NAME.CREATE_TEAM_TEAM_INFO,
      params: {
        activityId: store.getters['activity/activityId']
      }
    };
  }
}, {
  path: '/create_team/team_info/:activityId',
  name: ROUTE_NAME.CREATE_TEAM_TEAM_INFO,
  meta: {
    title: function title(to) {
      var basicInfo = store.state.activity.basicInfo[to.params.activityId];
      var name = basicInfo ? basicInfo.name : '';
      return name + "\u6218\u961F\u4FE1\u606F\u63D0\u4EA4";
    },
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "create_team" */
    '@/pages/createTeam/teamInfo.vue');
  }
}, {
  path: '/create_team/team_info/:activityId/:teamId',
  redirect: function redirect(to) {
    return {
      name: ROUTE_NAME.MONITOR_SETTING_BEFORE,
      params: to.params
    };
  }
}];